import React from 'react';

const Header = () => {
  return (
    <header className="py-4 bg-transparent"> {/* Cambiamos bg-white a bg-transparent */}
      <div className="max-w-3xl mx-auto flex justify-center">
        {/* Ajustamos las dimensiones del logo */}
        <img 
          src="/logotipo.svg" // Asegúrate de que el logo esté en la carpeta pública
          alt="Logotipo"
          className="h-[87px] w-[170px]" // Dimensiones exactas: 170px de ancho y 87px de alto
        />
      </div>
    </header>
  );
};

export default Header;